import type { FC, ReactElement } from "react"

import { ETypographyColor, ETypographySize, ETypographyWeight, Link, Typography } from "@/3514/components"
import { withPressHandler } from "@/3514/utils"
import { type IUseTranslation, useTranslation } from "@/hooks"
import { type TEmptyCallback, emptyAsyncCallback } from "@/shared/types/functions"

import { useCoachingChatContext as useChatContext } from "../../context"
import { coachingChatStyles as chatStyles } from "../../styles"

const {
    modals: { guide: classes }
} = chatStyles

const Opener: FC = (): ReactElement => {
    const {
        guide: { handleModalOpen }
    }: ReturnType<typeof useChatContext> = useChatContext()

    const { t }: IUseTranslation = useTranslation()

    const openAction: TEmptyCallback = (): void => handleModalOpen({ onSubmit: emptyAsyncCallback })

    return (
        <div className={classes.modalOpener}>
            <Typography
                size={ETypographySize.Small}
                color={ETypographyColor.Dark}
                text={t("entities.coachingChat.guideModal.opener")}
            />
            {/* eslint-disable-next-line */}
            <Link
                textWeight={ETypographyWeight.Default}
                textSize={ETypographySize.Small}
                onClick={withPressHandler(openAction)}
                onKeyDown={withPressHandler(openAction)}
                to="#"
            >
                {t("entities.coachingChat.guideModal.openerAction")}
            </Link>
        </div>
    )
}

Opener.displayName = "CoachingChatGuideModalOpener"

export { Opener as CoachingChatGuideModalOpener }
